export default "__VITE_ASSET__BJK_gEdb__"